/*
 * Copyright (c) Nexign, JSC, 2022-2025.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.19.0
 */

import { useSelector } from 'react-redux';

import ArrowTooltip from '@/main/components/common/Tooltip/Tooltip';
import { getIsFastBasketPage } from '@/main/components/Table/utils/tableUtils';

import { tableBasketAllInSelector, tableDataCountSelector, tableFastBasketAllInSelector } from '../../../selectors';
import TableHeader from '../../TableHeader';
import CheckboxCell from './CheckboxCell';

const CheckboxHeader = (props: {disabled?: boolean, disabledMessage?: string}) => {

    const { disabled, disabledMessage } = props;

    const count = useSelector(tableDataCountSelector);
    const basketAllIn = useSelector(tableBasketAllInSelector);
    const fastBasketAllIn = useSelector(tableFastBasketAllInSelector);

    const isFastBasketPage = getIsFastBasketPage();

    return (
        <TableHeader label="" name="checked">
            <ArrowTooltip
                disableHoverListener={!disabledMessage}
                message={disabledMessage}
                placement="left-start"
                title=""
            >
                <div style={{ marginTop: 12 }}>
                    <CheckboxCell
                        checked={isFastBasketPage ? fastBasketAllIn : basketAllIn}
                        disabled={count === 0 || disabled}
                    />
                </div>
            </ArrowTooltip>
        </TableHeader>
    );
};

export default CheckboxHeader;
